import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import BasicButton from '../../../../../../components/BasicButton';
import ROUTE from '../../../../../../constants/route';
import {Permission, Role} from '../../../../../../helpers/user';

const GatButton = props => {
  const { user, history } = props;

  const show = useMemo(
    () => Permission.isAllowedRunAptitudeTest(user.permissions),
    [user]
  );

  const handleClickGatTest = () => {
    if (Role.isCandidate(user, true)) {
      history.push(ROUTE.CANDIDATE_APTITUDE);
    }
  };

  return show ? (
    <div className="sidebar__button">
      <BasicButton
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={600}
        btnText="Take gat test"
        btnArrow={true}
        controlFunc={handleClickGatTest}
        btnBg="#fff"
        btnHoverBg="#f40"
      />
    </div>
  ) : null;
};

GatButton.propTypes = {
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default GatButton;
